import { EdgeSource } from '../components/organisms/ConnectedTableDashlet/ConnectedTableDashlet';

export const getTableRequestChunks = (
  sources: EdgeSource[],
  size = 10
): EdgeSource[][] => {
  let i = 0;
  const requests: EdgeSource[][] = [[]];

  for (let j = 0; j < sources.length; j++) {
    requests[i].push(sources[j]);
    if ((j + 1) % size === 0) {
      requests.push([]);
      i++;
    }
  }

  return requests;
};
